import { DateService } from '@atlas/core';

import { bonusStatuses, FREESPIN_STATUS } from 'common/constants';

const { CANCELED, COMPLETED, DISABLED, EXPIRED, SPEND } = bonusStatuses;

export const FINISHED_BONUS_DETAILS_SOURCE = {
  CLIENT_BONUS: 'CLIENT_BONUS',
  CLIENT_FREESPIN: 'CLIENT_FREESPIN',
};

// finished bonus/freespin dates always show the full day/month/year (matches the
// bonus card and design) regardless of the skin's short date config
export const FINISHED_BONUS_DETAILS_DATE_FORMAT = 'DD/MM/YYYY';

const CLIENT_BONUS_FINISHED_DETAILS_STATUSES = new Set([
  COMPLETED,
  EXPIRED,
  CANCELED,
  DISABLED,
  SPEND,
]);

export const isClientBonusFinishedDetailsStatus = status =>
  status != null && CLIENT_BONUS_FINISHED_DETAILS_STATUSES.has(status);

const CLIENT_FREESPIN_FINISHED_DETAILS_STATUSES = new Set([
  FREESPIN_STATUS.CANCELED,
  FREESPIN_STATUS.DISABLED,
  FREESPIN_STATUS.EXPIRED,
  FREESPIN_STATUS.USED,
]);

export const isClientFreespinFinishedDetailsStatus = status =>
  status != null && CLIENT_FREESPIN_FINISHED_DETAILS_STATUSES.has(status);

export const formatWagerDisplay = wager => {
  if (wager == null || wager === '') {
    return null;
  }

  if (typeof wager === 'number') {
    return `x${wager}`;
  }

  return String(wager);
};

export const formatFinishedBonusDetailsDate = ms => {
  if (ms == null) {
    return null;
  }

  return DateService.getFormattedDate(ms, FINISHED_BONUS_DETAILS_DATE_FORMAT);
};

// use one CMS key for exactly one day and another for everything else
export const finishedBonusPeriodDaysLabelKey = dayCount => (dayCount === 1 ? 'day' : 'timer_days');

export const statusDateLabelKey = status => {
  switch (status) {
    case COMPLETED:
      return 'finished_bonuses_completed_date';
    case EXPIRED:
      return 'finished_bonuses_expiration_date';
    case CANCELED:
      return 'finished_bonuses_canceled_date';
    case DISABLED:
      return 'finished_bonuses_disabled_date';
    case SPEND:
      return 'finished_bonuses_spend_date';
    default:
      return '';
  }
};

// freespins use dedicated date label keys so translations can differ from bonuses
export const freespinStatusDateLabelKey = status => {
  switch (status) {
    case FREESPIN_STATUS.USED:
      return 'finished_freespins_completed_date';
    case FREESPIN_STATUS.EXPIRED:
      return 'finished_freespins_expiration_date';
    case FREESPIN_STATUS.CANCELED:
      return 'finished_freespins_canceled_date';
    case FREESPIN_STATUS.DISABLED:
      return 'finished_freespins_disabled_date';
    default:
      return '';
  }
};
